<template>
  <div id="tavolos-hotelintel">
    <div class="tavolos-hotelintel-header">
      <div class="tavolos-hotelintel-logo">
        <img :src="logo_src">
      </div>
    </div>
    <div class="tavolos-hotelintel-content">
      <transition name="tavolos-slide-right-fade" mode="out-in">
        <Book :restaurant_id="restaurant_id" :publisher_id="publisher_id"></Book>
      </transition>
    </div>
  </div>
</template>

<script>

  import Book from './Book.vue'

  export default {
    components: {
      Book
    },

    data () {
      return {
        logo_src: 'https://widget.tavolos.com/src/assets/publisher/hotelintel-logo.png',
      }
    },

    props: [
      'restaurant_id',
      'publisher_id'
    ],
  }
</script>

<style lang="scss" scoped>

  #tavolos-hotelintel {
    .tavolos-hotelintel-header {
      margin-bottom: 20px;  
    }
    .tavolos-hotelintel-logo img {
      display: block;
      margin: auto;
      max-height: 60px;
      width: auto;
    }
  }
  #tavolos-about {
    margin: 50px 0;
  }

  @media (min-width: 600px) {

  }

</style>



// WEBPACK FOOTER //
// src/components/HotelIntel.vue